import type { Transaction } from '@src/domains/transactions/types/transaction';

export const requiresRedirect = (transaction: Transaction): transaction is Transaction & { paymentUrl: string } =>
  Boolean(transaction.pending && transaction.paymentUrl);
